export default {"src":"/_next/static/media/back_black.80bf590e.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};